/**
 * Co-located React Query key factory for the messaging module's mutation
 * invalidations. New keys land here per the stale-after-save convention;
 * the legacy inline literals in ThreadPage / InboxPage are grandfathered
 * in src/test/staleAfterSaveGate.test.ts and can migrate over time.
 */
export const messagingKeys = {
  /**
   * Conversations that attach a specific record (drives the entity
   * Messages tab via /messages/related/{type}/{id}). Mirrored by the
   * server route shape so the SPA can invalidate after a send that
   * touched the same record.
   */
  related: (resourceType: string, resourceId: string) =>
    ["messaging", "related", resourceType, resourceId] as const,
};
